export default __webpack_public_path__ + "static/media/info-orange.f2a4e4b8.svg";